import React, { createContext, useMemo, useState } from "react";

export const MapRadiusDataContext = createContext({});

export function MapRadiusDataProvider({ children }) {
  const [page, setPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(false);
  const [awaitingResponse, setAwaitingResponse] = useState(false);
  const [validFile, setValidFile] = useState(false);
  const [postResponse, setPostResponse] = useState({});
  const [radius, setRadius] = useState(null);
  const [userCoordinates, setUserCoordinates] = useState({});
  const [coordinates, setCoordinates] = useState({
    postal_code: null,
    lat: null,
    lng: null,
  });

  const props = useMemo(
    () => ({
      page,
      setPage,
      edit,
      setEdit,
      open,
      setOpen,
      message,
      setMessage,
      awaitingResponse,
      setAwaitingResponse,
      validFile,
      setValidFile,
      postResponse,
      setPostResponse,
      coordinates,
      setCoordinates,
      userCoordinates,
      setUserCoordinates,
      radius,
      setRadius,
    }),
    [
      page,
      edit,
      open,
      message,
      awaitingResponse,
      validFile,
      postResponse,
      coordinates,
      userCoordinates,
      radius,
    ]
  );

  return (
    <MapRadiusDataContext.Provider value={props}>
      {children}
    </MapRadiusDataContext.Provider>
  );
}
